'use client';

import * as RadixDialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { cx } from 'class-variance-authority';
import { Command } from 'cmdk';
import { forwardRef } from 'react';
import Overlay from '../../../overlay';

type CommandDialogProps = {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  position?: 'popper' | 'fixed';
  className?: string;
  shouldFilter?: boolean;
};

const CommandContainer = forwardRef<HTMLDivElement, CommandDialogProps>(
  ({ children, open, onOpenChange, position = 'fixed', className, shouldFilter = true }, ref) => {
    const handleClose = () => onOpenChange(false);

    return (
      <RadixDialog.Root open={open} onOpenChange={onOpenChange} modal>
        <RadixDialog.Portal>
          <RadixDialog.Overlay asChild>
            <Overlay isVisible={open} className="z-[9999]!" />
          </RadixDialog.Overlay>
          <RadixDialog.Content
            className={cx(
              'fixed z-[9999] bg-primary shadow-lg rounded-lg overflow-hidden w-[600px] max-w-[calc(100vw-32px)] outline-none',
              position === 'fixed' && 'top-20 left-1/2 -translate-x-1/2',
              className,
            )}
            onEscapeKeyDown={handleClose}
            onPointerDownOutside={handleClose}
            aria-describedby={undefined}
          >
            <VisuallyHidden>
              <RadixDialog.Title>Command menu</RadixDialog.Title>
            </VisuallyHidden>
            <Command ref={ref} shouldFilter={shouldFilter}>
              {children}
            </Command>
          </RadixDialog.Content>
        </RadixDialog.Portal>
      </RadixDialog.Root>
    );
  },
);

export default CommandContainer;
